<div :class="$style.fouNavigation" @mouseleave="setMenu" role="navigation" v-if="isValidPermissionArr()" >
  <div :class="[$style.mobileQuickLinkWrapper, showHamIcon ? $style.open : '', !user.authenticated && $style.padding10Tb ]">
    <!-- Side Navigation Footer -->
    <div :class="[ $style.mobileQuickLink ]" >
      <!-- Create Promotions -->
      <div :class="$style.navItem" v-if="user.authenticated && isValidNavigation && (getNavigationTabsPermission('promotions') || hasRole(['foundrySupport'])) && !hasRole(['FS-Impersonate']) && !hasRole(['foundryUser']) && !hasRole([''])" >
        <a
          :class="[$style.navItemLink]"
          :id="$vId(this, 'promotions')"
          @click="closeSideNav"
          href="/promos/new-promo">
          <star-icon :className="$style.navIcon" width="16" height="16"/>
          {{$t('components.general.fou_navigation.create_new_promotion')}}
        </a>
      </div>
      <!-- Create Submission -->
      <div :class="$style.navItem" v-if="user.authenticated && isValidNavigation && (getNavigationTabsPermission('submissions') || hasRole(['FS-Impersonate']))" >
        <div :class="$style.navItem" v-if="!checkSupportUser">
          <MdTooltip v-if="isContractLocked" trigger="hover" padding="medium" hidedelay="0" placement="top">
            <a slot="trigger"
              :class="[$style.navItemLink, 'disabled']"
              :id="$vId(this, 'submission')">
              <upload-icon :className="$style.navIcon" width="16" height="16"/>
              {{$t('components.general.fou_navigation.submit_fonts')}}
            </a>
            <span slot="content" class="fou-tooltip__content">
              {{ $t('components.general.contract_termination.tooltip.label') }}
            </span>
          </MdTooltip>
          <a
            v-else
            :class="[$style.navItemLink]"
            :id="$vId(this, 'submission')"
            @click="createNewSubmission()">
            <upload-icon :className="$style.navIcon" width="16" height="16"/>
            {{$t('components.general.fou_navigation.submit_fonts')}}
          </a>
        </div>
      </div>
      <!-- brand your profile  -->
      <div :class="$style.navItem" v-if="user.authenticated && isValidNavigation && (getNavigationTabsPermission('Foundry Profile') || hasRole(['FS-Impersonate'])) && (!foundryBannerURL || !foundryLogoURL) && hasFoundryProfilePermission">
        <MdTooltip v-if="isContractLocked" trigger="hover" padding="medium" hidedelay="0" placement="top">
          <a slot="trigger"
            :class="[$style.navItemLink, 'disabled']"
            :id="$vId(this, 'branding')">
            <MdIconCompany :className="$style.navIcon" color="blue-duck--500"/>
            {{$t('components.general.fou_navigation.brand_your_profile')}}
          </a>
          <span slot="content" class="fou-tooltip__content">
            {{ $t('components.general.contract_termination.tooltip.label') }}
          </span>
        </MdTooltip>
        <a
          v-else
          :class="[$style.navItemLink]"
          :id="$vId(this, 'branding')"
          @click="brandYourProfile()">
          <MdIconCompany :className="$style.navIcon" color="blue-duck--500"/>
          {{$t('components.general.fou_navigation.brand_your_profile')}}
        </a>
      </div>
      <!-- videos and articles  -->
      <div :class="[$style.navItem]" v-if="user.authenticated && isValidNavigation && !hasRole(['foundrySupport', 'bulkIngestionUser'])" >
        <MdTooltip v-if="isContractLocked" trigger="hover" padding="medium" hidedelay="0" placement="top">
          <a slot="trigger"
            :class="[$style.navItemLink, 'disabled']"
            :id="$vId(this, 'videos')">
            <MdIconResources :className="$style.navIcon" color="blue-duck--500"/>
            {{$t('components.general.fou_navigation.videos_and_articles')}}
          </a>
          <span slot="content" class="fou-tooltip__content">
            {{ $t('components.general.contract_termination.tooltip.label') }}
          </span>
        </MdTooltip>
        <a
          v-else
          :class="[$style.navItemLink]"
          :id="$vId(this, 'videos')"
          @click="navigateToVideos()">
          <MdIconResources :className="$style.navIcon" color="blue-duck--500"/>
          {{$t('components.general.fou_navigation.videos_and_articles')}}
        </a>
      </div>

       <!-- Support -->
       <div :class="$style.navItem" v-if="user.authenticated && isValidNavigation && !hasRole(['foundrySupport', 'bulkIngestionUser'])">
        <a
          :class="[$style.navItemLink]"
          :id="$vId(this, 'support')"
          href='https://foundrysupport.monotype.com'
          target='_blank'
          rel="noopener noreferrer">
          <MdIconComplianceExecution :className="$style.navIcon" color="blue-duck--500" />
          {{$t('components.general.fou_navigation.help')}}
        </a>
      </div>
    </div>
  </div>
</div>
